(function () {
  function initMegaMenuHover() {
    var parents = document.querySelectorAll('.cs-mega-parent');

    parents.forEach(function (parent) {
      // cs-mega-dropdown is position:fixed so it may not be a DOM child
      // Find it by looking inside the parent first, then globally by index
      var dropdown = parent.querySelector('.cs-mega-dropdown');
      if (!dropdown) return;

      var closeTimer = null;

      function openDropdown() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        dropdown.classList.add('is-open');
      }

      function scheduleClose() {
        closeTimer = setTimeout(function () {
          dropdown.classList.remove('is-open');
        }, 150);
      }

      parent.addEventListener('mouseenter', openDropdown);
      parent.addEventListener('mouseleave', scheduleClose);
      dropdown.addEventListener('mouseenter', openDropdown);
      dropdown.addEventListener('mouseleave', scheduleClose);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  } else {
    initMegaMenuHover();
  }
})();

// ── Shop-the-feed slider: play videos after next/prev button click ──
(function () {
  function triggerVisibleVideos(sliderEl) {
    if (!sliderEl) return;
    var page = parseInt(sliderEl.getAttribute('data-page') || '0', 10);
    var visibleItems = Math.round(sliderEl.parentElement.offsetWidth / (sliderEl.lastChild.offsetWidth || 1));
    var startIndex = page * visibleItems;
    var children = Array.from(sliderEl.children);

    children.forEach(function (child, i) {
      var videoJs = child.querySelector('video-js, [data-video-autoplay]');
      var video = child.querySelector('video');
      if (!video) return;

      if (i >= startIndex && i < startIndex + visibleItems) {
        // Reset played flag so IntersectionObserver or manual play works
        video.classList.remove('played');
        // Dispatch playVideo event that VideoJs component listens to
        if (videoJs) {
          videoJs.dispatchEvent(new CustomEvent('playVideo'));
        } else {
          // Fallback: trigger mouseover on video_on_hover parent
          var hoverParent = child.querySelector('.video_on_hover');
          if (hoverParent) {
            hoverParent.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
          } else {
            video.play().catch(function () {});
          }
        }
      } else {
        // Pause videos not in view
        video.pause();
        video.classList.remove('played');
      }
    });
  }

  function initSliderVideoSync() {
    var feedSection = document.querySelector('[data-section-name="shop-the-feed"]');
    if (!feedSection) return;

    var container = feedSection.querySelector('.featured-collection-items');
    if (!container) return;

    var prevBtn = container.querySelector('.slider-desktop__buttons__prev');
    var nextBtn = container.querySelector('.slider-desktop__buttons__next');
    var sliderEl = container.querySelector('slider-component.slider-desktop');

    if (!sliderEl) return;

    function onButtonClick() {
      // Wait for transform transition to finish (~300ms)
      setTimeout(function () {
        triggerVisibleVideos(sliderEl);
      }, 320);
    }

    if (prevBtn) prevBtn.addEventListener('click', onButtonClick);
    if (nextBtn) nextBtn.addEventListener('click', onButtonClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliderVideoSync);
  } else {
    initSliderVideoSync();
  }
})();
